import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CommonHttpModule } from '../../providers/commonHttpModule';
import { MaClient } from 'src/app/modules/Disbursment_modules/dis-repository/pages/create-client/client.model';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  constructor(private http: CommonHttpModule) {}

  // method to send the data from db
  ClientDataToDB(data: MaClient): Observable<any> {
    const transformedData: MaClient = {
      ...data,
      status: data.status === true ? 'Y' : 'N',
    };
    return this.http.post('clients', transformedData).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  ClientDataFromDb(
    body: any,
  ): Observable<{ total_count: number; data: MaClient[] }> {
    return this.http
      .post<{ total_count: number; data: MaClient[] }>('clientlist', body)
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  VslListFromDb(body: any): Observable<any> {
    return this.http.post<any>('vessels-by-assignment', body).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  postRequest(body: any): Observable<any> {
    return this.http.post<any>('client_initiate_disbursement', body).pipe(
      map((response) => {
        return response;
      }),
    );
  }
  checkDuplicateDisbursement(payload: { vessel_id: number; port_id: number; eta: any; check_type?: string }): Observable<any> {
  return this.http.post<any>('check_duplicate_disbursement', payload);
}
  getDisbursementTimelineAll(): Observable<any> {
    return this.http.get<any>('disbursement_timeline_all').pipe(
      map((response) => {
        return response;
      }),
    );
  }

  getDisbursementTimeline(requestId: number | string): Observable<any> {
    return this.http.get<any>(`disbursement_timeline/${requestId}`).pipe(
      map((response) => {
        return response;
      }),
    );
  }
  notifyMissingEntities(payload: any): Observable<any> {
    return this.http.post<any>('notify_missing_entities', payload).pipe(
      map((response) => {
        return response;
      }),
    );
  }
  getDisbursementDetailsById(disbursementId: string): Observable<any> {
    return this.http.get<any>(`client_initiate_disbursement_detail/${disbursementId}`);
  }
}
